<template>

  <div class="nav-bar">

    <div class="page-header-left"><img @click="toWebPage"
                                       src="@/assets/images/share/pc-logo-new.png"
                                       alt="" class="logo">
      <div class="slogan"> 永不限速 免登录下载</div>
    </div>

    <div :class="isLogin ? 'topage-container': 'topage-container width-wrapper'" @click="toWebPage">
      <span class="toweb-page">访问网页版</span>
    </div>

    <div class="login-container" v-if="!isLogin">
      <button class="login-btn" @click="loginToIndex()">登录</button>
    </div>


    <!--    <img src="@/assets/images/share/vipNot.png" v-if="isLogin&&store.state.admin.account.info.vipName==undefined" style="height: 19px;position: absolute;right: 23px;top: 36px;z-index: 10">-->
    <img src="@/assets/images/share/vipAva.png" v-if="isLogin&&store.state.admin.account.info.vipName=='VIP'"
         style="height: 19px;position: absolute;right: 34px;top: 36px;z-index: 10">
    <img src="@/assets/images/share/svipAva.png" v-if="isLogin&&store.state.admin.account.info.vipName=='SVIP'"
         style="height: 19px;position: absolute;right: 34px;top: 36px;z-index: 10">
    <img src="@/assets/images/share/ssvipAva.png" v-if="isLogin&&store.state.admin.account.info.vipName=='SSVIP'"
         style="height: 19px;position: absolute;right: 34px;top: 36px;z-index: 10">

    <div class="nav-bar-right" @click="changeShow" v-if="isLogin">
      <img :src="getUserInfo(1)" class="nav-avatar">
    </div>

    <div class="userinfo-container" v-if="userinfoShow" ref="getUserInfoDom">
      <div class="userinfo-bar">
        <div class="first">
          <img :src="getUserInfo(1)" class="nav-avatar">
          <span class="first-username">{{ getUserInfo(2) }}</span>
        </div>
        <div class="second" @click="downApp">
          <span class="second-desc">下载应用</span>
        </div>
        <div class="third" @click="logout">
          <span class="third-desc">退出登录</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {reactive, computed, toRefs, watch} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useStore} from 'vuex'
import util from '@/libs/util';
import defaultAvatar from "@/assets/images/tab_mine/avatar/default.png";
import signUtils from "@/libs/signUtils";

export default {
  name: "NavBar",
  props: {
    shareItem: {
      type: Object,
      require: false,
      default: () => {
        return {}
      }
    }
  },
  emits: ['NavBarLogin', 'LogincloseModel'],
  setup(props, context) {

    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    let data = reactive({
      userinfoShow: false,
      getUserInfoDom: null
    })

    document.addEventListener("click", e => {
      if (data.getUserInfoDom != null) {
        if (!data.getUserInfoDom.contains(e.target)) {
          if (e.target.className != 'nav-bar-right' && e.target.className != 'nav-avatar') {
            data.userinfoShow = false
          }
        }
      }
    });

    let isLogin = computed(() => {
      return store.state.admin.account.info.avatar != undefined || store.state.admin.account.info.name != undefined
    })


    function getUserInfo(val) {
      if (val == 1) {
        let localAvatar = store.state.admin.account.info.avatar
        if (localAvatar == undefined || localAvatar == null || localAvatar == '') {
          return defaultAvatar
        }
        if (localAvatar.indexOf('assets') == 0) {
          let url = localAvatar.slice(0, localAvatar.lastIndexOf('.'))
          return require('@/' + `${url}` + '.png')
        } else {
          return localAvatar
        }
      }
      if (val == 2) {
        return store.state.admin.account.info.name
      }
    }

    function loginToIndex() {
      context.emit('NavBarLogin')
    }

    function toWebPage() {
      let shareUrl = localStorage.getItem('downAppUrl')
      if (props.shareItem[0].map.userId != undefined) {
        shareUrl = shareUrl + '/d/' + signUtils.encryptHex(props.shareItem[0].map.account)
      }
      let token = util.cookies.get('appToken')
      if (token == undefined) {
        window.open(shareUrl)
      } else {
        let url = 'https://www.feijipan.com/console/files/0?title=我的文件sattus=1&appToken=' + token
        window.open(url)
      }
    }

    function downApp() {
      window.open('https://www.feijipan.com/downloads')
    }

    function logout() {
      store.dispatch("admin/account/logout")
      setTimeout(() => {
        util.cookies.remove('appToken');
        store.commit("admin/account/COMMIT_ACCOUNT_INFO", {})
      }, 1000)
      data.userinfoShow = false
      context.emit('LogincloseModel')
      // router.push('/')
    }

    function changeShow() {
      data.userinfoShow = !data.userinfoShow
    }


    return {
      store,
      toWebPage,
      downApp,
      logout,
      isLogin,
      loginToIndex,
      getUserInfo,
      changeShow,
      ...toRefs(data)
    }

  }
}
</script>

<style scoped>

.nav-bar {
  height: 60px;
  width: 100%;
  box-shadow: 3px 3px 10px #EEEEEE;
  background-color: white;
  position: fixed;
  z-index: 111;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}


.page-header-left {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.page-header-left .logo {
  width: 128px;
  cursor: pointer;
}

.page-header-left .slogan {
  width: 153px;
  height: 34px;
  background-color: #DAECFF;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  letter-spacing: 0.2px;
  font-family: 'PingFang SC';
  font-size: 13px;
  line-height: 15px;
  text-align: center;
  color: #0982FE;
}

.page-header-left .slogan img {
  width: 131px;
}

.topage-container {
  width: 80px;
  height: 30px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 105px;
}

.width-wrapper {
  right: 154px;
}

.toweb-page {
  cursor: pointer;
  font-family: 'PingFang SC';
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #B4B6C0;
}

.topage-container:hover {
  background-color: #F5F5F5;
}

.login-container {
  position: absolute;
  right: 40px;
}

.login-btn {
  width: 80px;
  height: 30px;
  border: none;
  outline: none;
  cursor: pointer;
  background: #0982FE;
  border-radius: 11px;
  font-family: 'PingFang SC';
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
}


.nav-bar-right {
  position: absolute;
  right: 40px;
}

.nav-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  cursor: pointer;
}

.userinfo-container {
  width: 200px;
  height: 130px;
  border-radius: 10px;
  border: 1px solid #F5F5F6;
  background-color: white;
  z-index: 1024;
  position: absolute;
  right: 35px;
  top: 46px;
}

.userinfo-bar {
  margin-top: 10px;
  margin-left: 12px;
  width: 185px;
  height: 115px;
}

.first {
  display: flex;
  align-items: center;
  height: 44px;
  width: 100%;
  color: gray;
}

.first-username {
  font-size: 15px;
  margin-left: 10px;
  height: 44px;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.second {
  margin-top: 2px;
  height: 35px;
  border-bottom: 1px solid #F5F5F5;
  display: flex;
  align-items: center;
  color: gray;
  cursor: pointer;
}

.second-desc {
  font-size: 15px;
}

.third {
  height: 35px;
  display: flex;
  align-items: center;
  color: gray;
  cursor: pointer;
}

.third-desc {
  font-size: 15px;
}

img {
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

</style>
